export type CountryCode = 'US' | 'IN';

export interface PricingPlan {
  restrocalls: { amount: number; display: string };
  restroplay: { amount: number; display: string };
  bundle: {
    amount: number;
    display: string;
    originalAmount: number;
    originalDisplay: string;
    savings: string;
    savingsBadge: string;
  };
}

export interface CountryConfig {
  code: CountryCode;
  name: string;
  currency: string;
  flag: string;
  paymentGateway: 'stripe' | 'razorpay';
  pricing: PricingPlan;
}

export const COUNTRY_CONFIGS: Record<CountryCode, CountryConfig> = {
  US: {
    code: 'US',
    name: 'United States',
    currency: 'USD',
    flag: '🇺🇸',
    paymentGateway: 'stripe',
    pricing: {
      restrocalls: { amount: 79.99, display: '$79.99' },
      restroplay: { amount: 49.99, display: '$49.99' },
      bundle: {
        amount: 99.99,
        display: '$99.99',
        originalAmount: 129.98,
        originalDisplay: '$129.98/mo',
        savings: 'Save $30/mo',
        savingsBadge: 'SAVE 20%',
      },
    },
  },
  IN: {
    code: 'IN',
    name: 'India',
    currency: 'INR',
    flag: '🇮🇳',
    paymentGateway: 'razorpay',
    pricing: {
      restrocalls: { amount: 4999, display: '₹4,999' },
      restroplay: { amount: 999, display: '₹999' },
      bundle: {
        amount: 5499,
        display: '₹5,499',
        originalAmount: 5998,
        originalDisplay: '₹5,998/mo',
        savings: 'Save ₹499/mo',
        savingsBadge: 'SAVE 8%',
      },
    },
  },
};

export const DEFAULT_COUNTRY: CountryCode = 'US';

export async function detectCountry(): Promise<CountryCode> {
  try {
    const res = await fetch('https://ipapi.co/country_code/', { signal: AbortSignal.timeout(3000) });
    const code = (await res.text()).trim().toUpperCase();
    if (code === 'IN') return 'IN';
  } catch {
    // fall through to default
  }
  return 'US';
}
